'use strict';

var withStyles$1 = require('../../../../_virtual/withStyles.js_commonjs-exports.js');
var interopRequireDefault = require('../../../@babel/runtime/helpers/interopRequireDefault.js');
var _extends = require('../../../@babel/runtime/helpers/extends.js');
var index = require('../../../../_virtual/index.js_commonjs-proxy.js');
require('./defaultTheme.js');
var defaultTheme = require('../../../../_virtual/defaultTheme.js_commonjs-exports.js');

var _interopRequireDefault = interopRequireDefault;

Object.defineProperty(withStyles$1.__exports, "__esModule", {
  value: true
});
exports["default"] = withStyles$1.__exports.default = void 0;

var _extends2 = _interopRequireDefault(_extends._extends_1);

var _styles = index;

var _defaultTheme = _interopRequireDefault(defaultTheme.__exports);

function withStyles(stylesOrCreator, options) {
  return (0, _styles.withStyles)(stylesOrCreator, (0, _extends2.default)({
    defaultTheme: _defaultTheme.default
  }, options));
}

var _default = withStyles;
exports["default"] = withStyles$1.__exports.default = _default;

module.exports = exports["default"];
